import colors from '@constants/colors';

function TumblerDefault() {
  return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26" cy="26" r="25.5" fill={colors.gray1} stroke="#0D0F11"/>
            <path
                d="M22 16.0001L22.0009 14.6654C22.0017 13.5613 22.8969 12.6667 24.0009 12.6667H28.0009C29.106 12.6667 30.0017 13.563 30.0009 14.6681L30 16.0001"
                stroke="#0D0F11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M31 17.6667V26V35.5C31 36.0523 30.5523 36.5 30 36.5H22C21.4477 36.5 21 36.0523 21 35.5V23.5V17.6667C21 17.1145 21.4477 16.6667 22 16.6667H30C30.5523 16.6667 31 17.1145 31 17.6667Z"
                fill="white" stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
            <path d="M21.5 21H31" stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default TumblerDefault;
